import React from "react";
import { Box, Button } from "@mui/material";

export const ButtonBlue = ({onClick, children, sx={}, buttonProps, disabled, ...props}) => {
    return (
        <Box {...props} sx={{
            background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
            // left: '50%',
            borderRadius: '50px',
            padding: '5px 5px',
            // transform: 'translateX(-50%)',
            // position: 'absolute',
            // bottom: '-10px',
            width: { xs: 'auto', },
            ...sx
        }}>

            <Button
                sx={{
                    background: 'linear-gradient(to top, #01afff, #23b5ff, #36bbff, #46c1ff, #54c7ff, #5ecafe, #67cefe, #70d1fd, #78d2fc, #7fd4fa, #85d5f9, #8cd6f8)',
                    color: '#FFFFFF',
                    borderRadius: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: { xs: '10px 10px', sm: '10px 20px' },
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                    '&:not(:disabled):hover': {
                        background: 'linear-gradient(to top, #0156ff, #006bff, #007dff, #008eff, #009dff, #00a4ff, #00abff, #0fb2ff, #18b5ff, #1fb7ff, #26baff, #2cbcff)',
                        boxShadow: '0 6px 10px rgba(0, 0, 0, 0.3)',
                    },
                    '&:disabled': {
                        background: 'linear-gradient(to top, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC, #CCCCCC)',
                        boxShadow: '0 6px 10px rgba(0, 0, 0, 0.3)',
                    }
                }}
                onClick={onClick}
                disabled={disabled}
                {...buttonProps}
            >
                {children}
            </Button>
        </Box>
    )
}